<template>
  <div
    class="relative bg-white border rounded-xl shadow-sm hover:shadow-lg transition cursor-pointer flex flex-col h-full"
    @click="handleClick"
    tabindex="0"
    @keydown.enter="handleClick"
    role="button"
    :aria-label="option.title"
  >
    <div class="flex-1 flex flex-col p-6">
      <div class="flex items-center justify-between">
        <h3 class="text-lg font-bold text-gray-900 mb-2">{{ option.title }}</h3>
        <ChevronRightIcon class="h-5 w-5 text-gray-400 flex-none" aria-hidden="true" />
      </div>
      <div class="text-md text-gray-500 leading-relaxed mb-2 whitespace-pre-line">
        {{ option.description }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { ChevronRightIcon } from '@heroicons/vue/20/solid'

const props = defineProps({
  option: { type: Object, required: true }
})
const emit = defineEmits(['select'])

function handleClick () {
  emit('select', props.option)
}
</script>
